import { colors } from './core'

const accordion = {
  wrapper: {
    borderY: '1px solid',
    borderBottomColor: 'neutrals.2',
    borderTopColor: 'neutrals.2'
  },
  title: {
    textStyle: 'body.regular.regular',
    mr: 4

  },
  button: {
    py: 4,
    px: 0,
    open: {
      color: colors.secondary[1],
      svg: {
        path: {
          fill: colors.secondary[1]
        }
      }
    }
  }
}

export default accordion
